import { useEffect, useState, useRef } from "react";
import Home from "../Home/Home";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setSponsorsList } from "../../store/adminSlice";
import Link from "@mui/material/Link"
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";

const SponsorsList = () => {
  const dispatch = useDispatch();
  const sponsorsList = useSelector((state) => state.sponsorsList);
  const [sponsorList, setSponsorList] = useState(sponsorsList);
  const [openLoader, setOpenLoader] = useState(false);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (sponsorsList.length === 0) {
      setOpenLoader(true);
      fetch(process.env.REACT_APP_API_URL + "/sponsor/get/all")
        .then((response) => response.json())
        .then((sponsorList) => {
          dispatch(setSponsorsList(sponsorList));
          setOpenLoader(false);
          setSponsorList(sponsorList);
        });
    }
  }, []);

  return (
    <Home>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* {sponsorList && sponsorList.length > 0 && (
        <>
          <div className="container">
            <h3 style={{ marginTop: "50px" }}> Sponsors List </h3>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Name</b>
                    </TableCell>
                    <TableCell>
                      <b>Address</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sponsorList.map((sponsor, index) =>
                    sponsor.status === "A" ? (
                      <TableRow
                        key={sponsor.eventId || index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>{sponsor.sponsorName}</TableCell>
                        <TableCell>{sponsor.address}</TableCell>
                      </TableRow>
                    ) : null
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </>
      )} */}

      <div className="container">  
        <div className="four-column-layout">
          {sponsorList.map((sponsor, index) =>
        sponsor.status === "A" ? (
          <div className="sponsor_div">
          <img alt="nope" src="../logo.png"></img>
          <h1 className="sponsor_h1"> {sponsor.sponsorName} </h1>
          <h4 className="sponsor_h4"> {sponsor.address} </h4>
          <Link href={sponsor.sponsorLink} underline="hover" target="_blank">
            {sponsor.sponsorLink}
          </Link>
          </div>
          ) : null
      )}
        </div>
      </div>


    </Home>
  );
};

export default SponsorsList;
